// extracted by mini-css-extract-plugin
module.exports = {"info-table-modal":"_2JHeFJ-wEYR03AMhBZR5jU"};